import { Component, HostListener, Input} from '@angular/core';
import { ApplicationStatus } from 'src/app/models';
import { Activity, ActivityModel } from 'src/app/models/activities';
import { FeeDataEntity } from 'src/app/models/data-entities';
import { RelatedApplicationVM } from 'src/app/models/linked-application';

@Component({
  selector: 'app-application-status-card',
  standalone: false,
  templateUrl: './application-status-card.component.html',
  styleUrl: './application-status-card.component.scss'
})
export class ApplicationStatusCardComponent {

@Input() statusCode !: ApplicationStatus;
@Input() applicationNumber !: string;
@Input({required:false}) submitter !: string;
@Input({required:false}) appDate !: string;
@Input({required:false}) startedDate !: string;
@Input({required:false}) hasFees : boolean;
@Input({required:false}) fees : FeeDataEntity[]=[];
@Input({required:false}) currentActivity !:  Activity<ActivityModel>;
@Input({required:false}) applicationId : string;
@Input({required:false}) linkedApplications : RelatedApplicationVM[];


showLinkedApplications : boolean = false;

statusConfig: Record<ApplicationStatus, {
  label: string;
  bgColor: string;
  textColor: string;
  icon: string;
}> = {
  [ApplicationStatus.NotStarted]: {
    label: 'Not Started',
    bgColor: '#E3F2FD',
    textColor: '#1976D2',
    icon: 'hourglass_empty'
  },
  [ApplicationStatus.InProgress]: {
    label: 'In Progress',
    bgColor: '#FDEDED',
    textColor: '#D32F2F',
    icon: 'error'
  },
  [ApplicationStatus.Completed]: {
    label: 'Completed',
    bgColor: '#E8F5E9',
    textColor: '#2E7D32',
    icon: 'check_circle'
  },
  [ApplicationStatus.Voided]: {
    label: 'Voided',
    bgColor: '#F5F5F5',
    textColor: '#616161',
    icon: 'block'
  },
  [ApplicationStatus.Rejected]: {
    label: 'Rejected',
    bgColor: '#FDEDED',
    textColor: '#D32F2F',
    icon: 'cancel'
  },
  [ApplicationStatus.Discarded]: {
    label: 'Discarded',
    bgColor: '#FFF3E0',
    textColor: '#EF6C00',
    icon: 'delete'
  },
  [ApplicationStatus.Expired]: {
    label: 'Expired',
    bgColor: '#ECEFF1',
    textColor: '#455A64',
    icon: 'schedule'
  },
  [ApplicationStatus.Locked]: {
    label: 'Locked',
    bgColor: '#EDE7F6',
    textColor: '#5E35B1',
    icon: 'lock'
  },
  [ApplicationStatus.Withdrawn]: {
    label: 'Withdrawn',
    bgColor: '#FFFDE7',
    textColor: '#F9A825',
    icon: 'undo'
  }
};

@HostListener('document:click', ['$event'])
onDocumentClick(event: MouseEvent): void {
  if (!this.showLinkedApplications) {
    return;
  }

  const target = event.target as HTMLElement;

  // Keep it open if the click happened inside the related applications card
  if (target.closest('.estimated-total-card')) {
    return;
  }

  // Any click outside the card closes it
  this.showLinkedApplications = false;
}

@HostListener('window:scroll')
onWindowScroll(): void {
  if (this.showLinkedApplications) {
    this.showLinkedApplications = false;
  }
}

get currentStatus() {
  return this.statusConfig[this.statusCode];
}
toggleDetails(): void {
    this.showLinkedApplications = !this.showLinkedApplications;
  }
 

}
